/* ============================================
   SUGAR DADDY COFFEE — THEME JAVASCRIPT
   ============================================ */

(function() {
  'use strict';

  // ============ HEADER SCROLL ============
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  // ============ MOBILE NAV ============
  const mobileToggle = document.querySelector('.site-header__mobile-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function() {
      mobileToggle.classList.toggle('open');
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileToggle.classList.remove('open');
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ============ CART DRAWER ============
  const cartBtn = document.querySelector('[data-cart-trigger]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartClose = document.querySelector('.cart-drawer__close');
  const overlay = document.querySelector('[data-cart-overlay]');

  function openCart() {
    if (!cartDrawer || !overlay) return;
    cartDrawer.classList.add('open');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer || !overlay) return;
    cartDrawer.classList.remove('open');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeCart();
  });

  // ============ AJAX CART ============
  function fetchCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartUI(cart); })
      .catch(function(e) { console.error('Cart fetch error:', e); });
  }

  function updateCartUI(cart) {
    var countEl = document.querySelector('.site-header__cart-count');
    if (countEl) countEl.textContent = cart.item_count;

    var bodyEl = document.querySelector('.cart-drawer__body');
    if (!bodyEl) return;

    if (cart.item_count === 0) {
      bodyEl.innerHTML = '<div class="cart-drawer__empty"><h4>Your Cart</h4><p>is beautifully empty.</p><p style="margin-top:1rem;font-size:14px;">Explore our collection and treat yourself.</p></div>';
    } else {
      var html = '';
      cart.items.forEach(function(item, index) {
        var lineNum = index + 1;
        html += '<div class="cart-item" data-line-id="' + lineNum + '">' +
          '<div class="cart-item__image">' +
            (item.image ? '<img src="' + item.image.replace(/\.jpg/, '_100x125.jpg') + '" alt="' + item.title + '">' : '') +
          '</div>' +
          '<div class="cart-item__details">' +
            '<div class="cart-item__title">' + item.product_title + '</div>' +
            (item.variant_title ? '<div class="cart-item__variant">' + item.variant_title + '</div>' : '') +
            '<div class="cart-item__price">' + Shopify.formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-item__qty">' +
              '<button onclick="changeQty(' + lineNum + ', ' + (item.quantity - 1) + ')">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button onclick="changeQty(' + lineNum + ', ' + (item.quantity + 1) + ')">+</button>' +
            '</div>' +
            '<button class="cart-item__remove" onclick="changeQty(' + lineNum + ', 0)">Remove</button>' +
          '</div>' +
        '</div>';
      });
      bodyEl.innerHTML = html;
    }

    var subtotalEl = document.querySelector('.cart-drawer__subtotal-value');
    if (subtotalEl) subtotalEl.textContent = Shopify.formatMoney(cart.total_price);
  }

  window.changeQty = function(lineId, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: lineId, quantity: quantity })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartUI(cart); });
  };

  window.addToCart = function(variantId, quantity) {
    quantity = quantity || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function(r) { return r.json(); })
      .then(function() {
        fetchCart();
        openCart();
      });
  };

  // ============ VARIANT SELECTOR ============
  const variantOptions = document.querySelectorAll('.variant-option');
  const variantInput = document.querySelector('[data-variant-id]');
  const productForm = document.querySelector('[data-product-form]');

  if (variantOptions.length > 0) {
    variantOptions.forEach(function(option) {
      option.addEventListener('click', function() {
        const group = this.parentElement;
        group.querySelectorAll('.variant-option').forEach(function(o) { o.classList.remove('selected'); });
        this.classList.add('selected');

        if (productForm) {
          const selectedOptions = document.querySelectorAll('.variant-option.selected');
          const optionValues = Array.from(selectedOptions).map(function(o) { return o.getAttribute('data-option-value'); });

          if (window.productVariants) {
            const matched = window.productVariants.find(function(v) {
              return v.options.every(function(opt, i) { return opt === optionValues[i]; });
            });

            if (matched) {
              if (variantInput) variantInput.value = matched.id;
              updatePrice(matched);
            }
          }
        }
      });
    });
  }

  function updatePrice(variant) {
    const priceEl = document.querySelector('.product-info__price');
    const compareEl = document.querySelector('.product-info__price--compare');
    if (priceEl && variant) {
      if (variant.compare_at_price > variant.price && compareEl) {
        compareEl.style.display = 'inline';
        compareEl.textContent = Shopify.formatMoney(variant.compare_at_price);
      }
      priceEl.innerHTML = (variant.compare_at_price > variant.price && compareEl ? '<span class="product-card__price--compare">' + Shopify.formatMoney(variant.compare_at_price) + '</span>' : '') + Shopify.formatMoney(variant.price);
    }
  }

  // ============ QTY INPUT ============
  document.querySelectorAll('.qty-input').forEach(function(qi) {
    const minus = qi.querySelector('[data-qty-minus]');
    const plus = qi.querySelector('[data-qty-plus]');
    const input = qi.querySelector('input');

    if (minus) minus.addEventListener('click', function() {
      var v = parseInt(input.value) || 1;
      if (v > 1) input.value = v - 1;
    });
    if (plus) plus.addEventListener('click', function() {
      var v = parseInt(input.value) || 1;
      input.value = v + 1;
    });
  });

  // ============ PRODUCT GALLERY ============
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        const fullImg = this.getAttribute('data-full');
        if (fullImg) mainImg.src = fullImg;
      });
    });
  }

  // ============ PRODUCT TABS ============
  const tabButtons = document.querySelectorAll('.product-tabs__nav button');
  const tabPanels = document.querySelectorAll('.product-tabs__panel');
  if (tabButtons.length) {
    tabButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const target = this.getAttribute('data-tab');
        tabButtons.forEach(function(b) { b.classList.remove('active'); });
        tabPanels.forEach(function(p) { p.classList.remove('active'); });
        this.classList.add('active');
        const panel = document.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  }

  // ============ REVEAL ON SCROLL ============
  const revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -80px 0px' });

    revealEls.forEach(function(el) { observer.observe(el); });
  } else {
    revealEls.forEach(function(el) { el.classList.add('visible'); });
  }

  // ============ NEWSLETTER FORM ============
  // Newsletter forms submit natively to Shopify.

  // ============ CONTACT FORM ============
  const contactForm = document.querySelector('.contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function(e) {
      const submitBtn = contactForm.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.textContent = 'Sending...';
        submitBtn.disabled = true;
      }
    });
  }

  // ============ SORT DROPDOWN ============
  const sortSelect = document.querySelector('[data-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      window.location.href = this.value;
    });
  }

  // ============ INITIAL CART FETCH ============
  if (cartDrawer) fetchCart();

  // ============ MONEY FORMAT ============
  window.Shopify = window.Shopify || {};
  Shopify.formatMoney = function(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var format = (window.Shopify && Shopify.money_format) ? Shopify.money_format : '${{amount}}';

    function defaultOption(opt, def) { return (typeof opt === 'undefined' ? def : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    value = formatWithDelimiters(cents, 2);
    return format.replace(placeholderRegex, value);
  };

  // ============ SMOOTH SCROLL FOR ANCHOR LINKS ============
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target && this.getAttribute('href') !== '#') {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ============ PREDICTIVE SEARCH ============
  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchModal = document.querySelector('[data-search-modal]');
  const searchClose = document.querySelectorAll('[data-search-close]');
  const searchInput = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  const searchForm = document.querySelector('[data-search-form]');
  let searchTimeout = null;

  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (searchInput) setTimeout(function() { searchInput.focus(); }, 200);
  }

  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('open');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    if (searchResults) {
      searchResults.innerHTML = '<p class="search-modal__hint">Start typing to see results</p>';
    }
  }

  if (searchTrigger) searchTrigger.addEventListener('click', openSearch);
  searchClose.forEach(function(btn) { btn.addEventListener('click', closeSearch); });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && searchModal && searchModal.classList.contains('open')) closeSearch();
  });

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      var query = this.value.trim();

      if (query.length < 2) {
        if (searchResults) {
          searchResults.innerHTML = '<p class="search-modal__hint">Start typing to see results</p>';
        }
        return;
      }

      searchTimeout = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8')
          .then(function(r) {
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.json();
          })
          .then(function(data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) {
              if (searchResults) {
                searchResults.innerHTML = '<p class="search-modal__empty">No products found for "' + query + '"</p>';
              }
              return;
            }

            var html = '<div class="search-modal__results-list">';
            products.forEach(function(product) {
              var image = product.featured_image ? product.featured_image.url || product.featured_image : '';
              var price = product.price ? Shopify.formatMoney(product.price * 100) : '';

              html += '<a href="' + product.url + '" class="search-result-item">';
              if (image) {
                html += '<div class="search-result-item__image"><img src="' + image + '" alt="' + product.title + '" loading="lazy"></div>';
              } else {
                html += '<div class="search-result-item__image"></div>';
              }
              html += '<div class="search-result-item__details">';
              html += '<div class="search-result-item__title">' + product.title + '</div>';
              if (price) html += '<div class="search-result-item__price">' + price + '</div>';
              html += '</div></a>';
            });
            html += '</div>';
            html += '<div class="search-modal__footer"><a href="/search?type=product&q=' + encodeURIComponent(query) + '">View All Results &rarr;</a></div>';

            if (searchResults) searchResults.innerHTML = html;
          })
          .catch(function(e) {
            console.error('Search error:', e);
            if (searchResults) {
              searchResults.innerHTML = '<p class="search-modal__empty">Search is temporarily unavailable. Try the full search page.</p>';
            }
          });
      }, 300);
    });
  }

  // ============ FAQ ACCORDION ============
  var faqQuestions = document.querySelectorAll('.faq-item__question');
  faqQuestions.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.parentElement;
      var isOpen = item.classList.contains('open');
      faqQuestions.forEach(function(q) { q.parentElement.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // ============ FAQ CATEGORY FILTER ============
  var faqCategoryBtns = document.querySelectorAll('.faq-category-btn');
  var faqGroups = document.querySelectorAll('.faq-group');
  faqCategoryBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var category = this.getAttribute('data-category');
      faqCategoryBtns.forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');

      if (category === 'all') {
        faqGroups.forEach(function(g) { g.classList.remove('faq-group--hidden'); });
      } else {
        faqGroups.forEach(function(g) {
          if (g.getAttribute('data-category') === category) {
            g.classList.remove('faq-group--hidden');
          } else {
            g.classList.add('faq-group--hidden');
          }
        });
      }
    });
  });

})();